<template>
    <svg
        class="subscription-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        stroke="var(--palette-gray-100)"
        :style="{ color: 'var(--palette-gray-100)' }"
        fill="none">
        <g
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            fill="none">
            <path d="M12 2 2 7l10 5 10-5-10-5ZM2 17l10 5 10-5M2 12l10 5 10-5" />
        </g>
    </svg>
</template>
<script>
export default {
    name: 'SubscriptionIcon',
};
</script>
